import { useState } from "react";
import { useMediaQuery } from "react-responsive"; // <--- react-responsive
import StackKit from "@/shared/components/kit/stack";
import BoxKit from "@/shared/components/kit/box";
import Sidebar from "../components/sidebar";
import HamburgerMenu from "../components/sidebar/menuMobile";
import ContainerCustom from "@/shared/components/common/content";
import HeaderShare from "@/shared/components/common/header";
import { LogoUser } from "@/shared/components/common/icons";
import SidebarMobile from "../components/sidebar/menuMobile";

type LayoutProps = {
  children: React.ReactNode;
};

/**
 * Layout
 *
 * کامپوننت لایه‌بندی اصلی برنامه که شامل هدر، سایدبار و محتوای اصلی است.
 * این لایه واکنش‌گرا است و نمایش سایدبار را بر اساس اندازه صفحه نمایش تغییر می‌دهد:
 * - دسکتاپ: سایدبار همیشه نمایش داده می‌شود.
 * - موبایل: سایدبار به صورت کشویی با منوی همبرگری نمایش داده می‌شود.
 *
 * ویژگی‌ها:
 * - مدیریت وضعیت باز/بسته بودن سایدبار موبایل با useState
 * - تشخیص اندازه صفحه نمایش با useMediaQuery
 * - استفاده از کامپوننت‌های مشترک: Sidebar, HeaderShare, ContainerCustom
 * - محتوای اصلی (children) در مرکز صفحه با فاصله مناسب نمایش داده می‌شود
 *
 * Props:
 * @param children - محتوای اصلی که داخل لایه نمایش داده می‌شود
 *
 * @returns JSX.Element
 */

const Layout = ({ children }: LayoutProps) => {
  const [openDrawer, setOpenDrawer] = useState(false);

  // Define breakpoints
  const isDesktop = useMediaQuery({ minWidth: 1024 }); // lg breakpoint
  const isMobile = useMediaQuery({ maxWidth: 1023 });
  //TODO:main color
  return (
    <StackKit
      direction="row"
      className="w-full min-h-screen bg-[#F5F5F5] text-white overflow-hidden relative"
    >
      {/* ==== SIDEBAR (Desktop only) ==== */}
      {isDesktop && (
        <BoxKit className="flex-shrink-0 h-screen border-r border-[#333]">
          <Sidebar />
        </BoxKit>
      )}

      {/* ==== MAIN CONTENT AREA ==== */}
      <StackKit
        direction="column"
        className="flex-1 w-full overflow-y-auto flex flex-col min-h-screen"
      >
        {/* ==== HEADER ==== */}
        <HeaderShare logoHeader={<LogoUser />} setOpenDrawer={setOpenDrawer} />

        {/* ==== MOBILE SIDEBAR DRAWER ==== */}
        {isMobile && (
          <>
            <HamburgerMenu
              setOpenDrawer={setOpenDrawer}
              openDrawer={openDrawer}
            />
            {openDrawer && (
              <SidebarMobile
                setOpenDrawer={setOpenDrawer}
                openDrawer={openDrawer}
              />
            )}
          </>
        )}

        {/* ==== MAIN CONTENT WRAPPER ==== */}
        <StackKit
          direction="row"
          justifyContent="center"
          className="w-full flex-1"
        >
          <ContainerCustom>
            <StackKit className="w-full p-0 m-0 flex flex-col justify-center items-center gap-4">
              {children}
            </StackKit>
          </ContainerCustom>
        </StackKit>
      </StackKit>
    </StackKit>
  );
};

export default Layout;
